export default __webpack_public_path__ + "static/media/emptyAnnouncement.06eabb84.png";